// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"5fe97049","232":"fb9a9304","744":"1e2e6a8c","746":"a7eb76e6","931":"3e771a46"}[chunkId] + ".css";
};